const firm = {
  'companyName': '厦门乐榜网络科技有限公司',
  'companyAddress': '厦门市软件园二期观日路18号601',
  'businessCertificate': '闽ICP备17028024号-2',
  'copyright': '© 2014 - 2018',
  'siteName': '99 API',
  'keyword': '数据服务商,数据供应商',
  'memo': '大型数据服务供应商',
  'logo': '/img/center/logo.png',
  'coordinate': 'lng:118.160048,lat:24.510492',
  'email': 'support@99api.com',
  'phone': '19859808442',
  'code': '361006',
  'contact': {
    'customer': ['1756559391'],
    'wxCustomer': '/img/kefu02.png',
    'group': [
      // {
      //   'account': '交流群①(满)：217552193',
      //   'link': '//shang.qq.com/wpa/qunwpa?idkey=640b703bc3179f219c89fb12d06c2f6168e502647f8aaed7c85b2b81d5dde240'
      // },
      // {
      //   'account': '交流群②：235708007',
      //   'link': '//qm.qq.com/cgi-bin/qm/qr?k=QihSbovpoU1wtET9KzQcBo40yNDOHVwP&authKey=trY54NaaD5Xo1%2BruaoZGT0IxDm6wTH7X0FOd%2Fw9VQdaCdPxnDxou9Juq4zMPnsC6&noverify=0&group_code=235708007'
      // }
      {
        'account': '交流群：879828680',
        'link': '//qm.qq.com/cgi-bin/qm/qr?k=ghEtY_JIiMkW5ec0zcdwu1RueOI6kjl7&jump_from=webapi&authKey=8kME6udVlGQfaKATat99Ul0oucF1oQ/zzAeqcWpGLvwmhIHuUupfgsbRl1UBPSKw'
      }
    ]
    // 'group': {
    //   'account': ['217552193(满)', '235708007'],
    //   'link': ['//shang.qq.com/wpa/qunwpa?idkey=640b703bc3179f219c89fb12d06c2f6168e502647f8aaed7c85b2b81d5dde240', '//shang.qq.com/wpa/qunwpa?idkey=9996ef67922fcf29a2c732293ad8d3eaa8d529fb6080d6d2b5ad4de80846812e']
    // }
  }
}

export {firm}



// WEBPACK FOOTER //
// ./src/config/firm.js